import { render, staticRenderFns } from "./Emails.vue?vue&type=template&id=a95db88e&scoped=true&"
import script from "./Emails.vue?vue&type=script&lang=js&"
export * from "./Emails.vue?vue&type=script&lang=js&"
import style0 from "./Emails.vue?vue&type=style&index=0&id=a95db88e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a95db88e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a95db88e')) {
      api.createRecord('a95db88e', component.options)
    } else {
      api.reload('a95db88e', component.options)
    }
    module.hot.accept("./Emails.vue?vue&type=template&id=a95db88e&scoped=true&", function () {
      api.rerender('a95db88e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/monbi/settings/employees/Emails.vue"
export default component.exports